<template>
  <button 
    type="button"
    @click="toggle"
    :disabled="disabled"
    :class="[
      'relative inline-flex w-11 h-6 shrink-0 rounded-full p-0.5 ring-1 ring-inset ring-neutral-900/5 transition-colors duration-200 ease-in-out',
      modelValue ? 'bg-primary-500' : 'bg-neutral-200',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
    ]"
  >
    <span 
      class="block w-5 h-5 rounded-full bg-white shadow-sm ring-1 ring-neutral-900/5"
      :style="{
        transform: modelValue ? 'translateX(20px)' : 'translateX(0)',
        transition: 'transform 200ms ease-in-out'
      }"
    ></span>
  </button>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const toggle = () => {
  if (!props.disabled) {
    emit('update:modelValue', !props.modelValue);
  }
};
</script>
